import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { AnyoGridComponent } from 'projects/app-core/src/app/models/AnyoGridComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { Observable } from 'rxjs';
import {
  ForumListAdminResponse,
  ForumsListFilterData,
} from '../../../models/events/forumAdminGridResponse';
import {
  ForumListDateFilter,
  ForumListFilter,
  ForumListSort,
  ForumSearch,
  ForumsListGridRequest,
  ForumsListTab,
} from '../../../models/events/forumsGridRequest';
import { EventsService } from '../../../services/events.service';
import { DateFilterEmitData } from '../events-table/events-table.component';
import { ForumTableComponent } from '../forum-table/forum-table.component';

@Component({
  selector: 'app-manage-forums',
  templateUrl: './manage-forums.component.html',
  styleUrl: './manage-forums.component.scss',
})
export class ManageForumsComponent extends AnyoGridComponent<
  ForumListSort,
  ForumListFilter,
  ForumSearch,
  ForumListDateFilter,
  ForumsListGridRequest,
  ForumsListFilterData,
  ForumListAdminResponse
> {
  forumsTableQuery: ForumsListGridRequest | undefined;
  selectedTab: number = 0;
  tabs = [ForumsListTab.UP_COMING_ADMIN, ForumsListTab.ONGOING_ADMIN];
  globalSearchInput = '';
  hideTestEvent: boolean = false;

  currentFilters: {
    CATEGORY: string[];
    PRESENTER_ID: string[];
    ACTIVE: string[];
    USER_PERSONALISED: string[];
    PAYMENT_TYPE: string[];
    TEST_FORUMS: string[];
  } = {
      CATEGORY: [],
      PRESENTER_ID: [],
      ACTIVE: [],
      USER_PERSONALISED: [],
      PAYMENT_TYPE: [],
      TEST_FORUMS: ['false'],
    };
  // pageSize = 10;

  currentDateFilters?: Record<
    ForumListDateFilter,
    { from: Date; to: Date } | undefined
  >;

  @ViewChild('UpcomingTableComponent')
  UpcomingTableComponent?: ForumTableComponent;

  @ViewChild('AllTableComponent')
  AllTableComponent?: ForumTableComponent;

  @ViewChild('OngoingForumsComponent')
  OngoingForumsComponent?: ForumTableComponent;

  constructor(
    private eventsService: EventsService,
    private toastrService: ToastService,
    auth: AuthService,
    router: Router,
    route: ActivatedRoute,
    public utils: UtilsService,
  ) {
    super(auth, router, route);
  }

  protected override fetchGridData(
    request: ForumsListGridRequest,
  ): Observable<
    GridResponse<ForumsListFilterData | undefined, ForumListAdminResponse>
  > {
    return this.eventsService.listForums(request as ForumsListGridRequest);
  }

  override fetch(): void {
    this.tableLoading = true;
    const req = this.buildRequest(false);
    this.updateUrlWithQuery(req);
    this.fetchGridData(req).subscribe({
      next: (res) => {
        this.data = res.data;
        this.totalRecords = res.totalRecords;
        this.pageSize = res.pageSize;
        this.tableLoading = false;

        this.data.forEach((item) => {
          item.paymentTypeColor = this.utils.getRandomColor();
          item.categoryNameColor = this.utils.getRandomColor();
        });

        if (res.filterOptions) {
          if (this.UpcomingTableComponent) {
            this.UpcomingTableComponent.setCategoryFilterData(
              res.filterOptions,
            );
            this.UpcomingTableComponent.setPaymentTypeFilterData(
              res.filterOptions,
            );
            this.UpcomingTableComponent.setPresenterFilterData(
              res.filterOptions,
            );
          }

          if (this.OngoingForumsComponent) {
            this.OngoingForumsComponent.setCategoryFilterData(
              res.filterOptions,
            );
            this.OngoingForumsComponent.setPaymentTypeFilterData(
              res.filterOptions,
            );
            this.OngoingForumsComponent.setPresenterFilterData(
              res.filterOptions,
            );
          }

          if (this.AllTableComponent) {
            this.AllTableComponent.setCategoryFilterData(res.filterOptions);
            this.AllTableComponent.setPaymentTypeFilterData(res.filterOptions);
            this.AllTableComponent.setPresenterFilterData(res.filterOptions);
          }
        }
      },
      error: () => {
        this.tableLoading = false;
      },
    });
  }
  async tabChange($event: NzTabChangeEvent) {
    this.selectedTab = $event.index!;
    this.resetFilter();
  }

  async categoryFilter($event: string[]) {
    this.currentFilters.CATEGORY = $event && $event.length ? $event : [];
    this.page = 1;
    this.fetch();
  }

  async presenterFilter($event: string[]) {
    this.currentFilters.PRESENTER_ID = $event && $event.length ? $event : [];
    this.page = 1;
    this.fetch();
  }
  async paymentTypeFilter($event: string[]) {
    this.currentFilters.PAYMENT_TYPE = $event && $event.length ? $event : [];
    this.page = 1;
    this.fetch();
  }

  async activeFilter($event: string[]) {
    this.currentFilters.ACTIVE = $event && $event.length ? $event : [];
    this.page = 1;
    this.fetch();
  }

  async testFilter($event: boolean) {
    this.currentFilters.TEST_FORUMS = $event ? ['true'] : ['false'];
    this.hideTestEvent = $event;
    this.page = 1;
    this.fetch();
  }

  async dateFilter($event: DateFilterEmitData) {
    if ($event.dates && $event.dates.length) {
      const startDate = moment($event.dates[0]).startOf('day').toDate();
      const endDate = moment($event.dates[1]).endOf('day').toDate();

      const dateFilters: Record<
        ForumListDateFilter,
        { from: Date; to: Date } | undefined
      > = {
        [ForumListDateFilter.FORUM_START_DATE]: undefined,
        [ForumListDateFilter.REGISTRATION_CUT_OFF]: undefined,
        [ForumListDateFilter.VISIBLE_FROM]: undefined,
        [ForumListDateFilter.CREATED_DATE]: undefined,
      };
      if ($event.options.includes('forumStartDate')) {
        dateFilters[ForumListDateFilter.FORUM_START_DATE] = {
          from: startDate,
          to: endDate,
        };
      } else if ($event.options.includes('registrationCutOffDate')) {
        dateFilters[ForumListDateFilter.REGISTRATION_CUT_OFF] = {
          from: startDate,
          to: endDate,
        };
      } else if ($event.options.includes('visibleFrom')) {
        dateFilters[ForumListDateFilter.VISIBLE_FROM] = {
          from: startDate,
          to: endDate,
        };
      }
      this.currentDateFilters = dateFilters;
      this.page = 1;
      this.fetch();
    } else {
      this.currentDateFilters = undefined;
      this.page = 1;
      this.fetch();
    }
  }



  async resetFilter() {
    this.globalSearchInput = '';

    this.currentFilters = {
      CATEGORY: [],
      PRESENTER_ID: [],
      ACTIVE: [],
      USER_PERSONALISED: [],
      PAYMENT_TYPE: [],
      TEST_FORUMS: ['false'],
    };

    this.currentDateFilters = undefined;
    this.page = 1;
    this.hideTestEvent = false;
    if (this.UpcomingTableComponent) {
      this.UpcomingTableComponent.resetValues();
      this.UpcomingTableComponent.resetPresenterFilter();
      this.UpcomingTableComponent.resetSearch();
      this.UpcomingTableComponent.hideTestEvent = false;
    }
    if (this.AllTableComponent) {
      this.AllTableComponent.resetValues();
      this.AllTableComponent.resetPresenterFilter();
      this.AllTableComponent.resetSearch();
      this.AllTableComponent.hideTestEvent = false;
    }
    if (this.OngoingForumsComponent) {
      this.OngoingForumsComponent.resetValues();
      this.OngoingForumsComponent.resetPresenterFilter();
      this.OngoingForumsComponent.resetSearch();
      this.OngoingForumsComponent.hideTestEvent = false;
    }
    this.fetch();
  }

  async searchGlobal(searchTerm: string) {
    this.globalSearchInput = searchTerm;
    this.page = 1;
    this.fetch();
  }

  protected override buildRequest(exportFlag?: boolean): ForumsListGridRequest {
    const req: ForumsListGridRequest = {
      sort: undefined,
      dateFilters: this.currentDateFilters,
      page: this.page,
      pageSize: this.pageSize,
      export: exportFlag,
      filters: { ...this.currentFilters },
      globalSearch: this.globalSearchInput.length
        ? [this.globalSearchInput.trim()]
        : [],
      from: undefined,
      to: undefined,
      tab: this.tabs[this.selectedTab],
    } as ForumsListGridRequest;
    return req;
  }
  protected override applyRequestToState(req: ForumsListGridRequest): void {
    super.applyRequestToState(req);
    if (req.filters) {
      this.currentFilters = {
        CATEGORY: req.filters.CATEGORY ?? [],
        PRESENTER_ID: req.filters.PRESENTER_ID ?? [],
        ACTIVE: req.filters.ACTIVE ?? [],
        USER_PERSONALISED: req.filters.USER_PERSONALISED ?? [],
        PAYMENT_TYPE: req.filters.PAYMENT_TYPE ?? [],
        TEST_FORUMS: req.filters.TEST_FORUMS ?? ['false'],
      };
    }
    if (req.filters?.TEST_FORUMS) {
      this.hideTestEvent = req.filters.TEST_FORUMS.includes('true');
    }
    if (req.dateFilters) this.currentDateFilters = req.dateFilters;
    if (req.globalSearch && req.globalSearch.length) {
      this.globalSearchInput = req.globalSearch[0];
    }
    if (req.tab) {
      const tabIndex = this.tabs.indexOf(req.tab);
      console.log(tabIndex);
      if (tabIndex !== -1) this.selectedTab = tabIndex;
    }
  }
}
